import React from 'react';
import {Dimensions, Text} from 'react-native';
import {Tooltip} from 'react-tooltip';
import {BREAKPOINT} from '../../../data/constants/screen';
import {Form} from './Form';

interface Props {
  content: string | undefined;
  title: string | undefined;
}
const TooltipWeb = ({title, content}: Props) => {
  return (
    <>
      <Text id="web-tooltip-anchor" style={{cursor: 'pointer'}}>
        i
      </Text>
      <Tooltip
        anchorSelect="#web-tooltip-anchor"
        style={{
          background: '#fff',
          fill: '#fff',
          color: '#000',
          maxWidth:
            Dimensions.get('screen').width > BREAKPOINT.sm ? '380px' : '340px',
          opacity: 1,
          boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
          zIndex: 50,
        }}
        place={'bottom-end'}
        clickable
        delayShow={100}>
        <Form title={title} content={content} />
      </Tooltip>
    </>
  );
};

export default TooltipWeb;
